module.exports = __webpack_public_path__ + "img/right-arrow.1deb411f.svg";